import { useQuery } from '@tanstack/react-query';
import { fetchItems, type ItemsFilter } from '@/api/client';
import type { LanguageCode } from '@/types';

export function useItems(lang: LanguageCode, filter: ItemsFilter) {
  return useQuery({
    queryKey: ['items', lang, filter],
    queryFn: () => fetchItems(lang, filter),
  });
}
